import React, { useState } from 'react';
import { styled, Typography } from '@mui/material';
import Column from 'src/frontend-common/components/Column';
import { LandingWrapper } from 'src/pages/LoginSimulatorLanding/style';
import FakeLoginForm from 'src/pages/ManualLookup/LoginSimulator/fakeLoginForm';
import LoginSimulatorOutcome from 'src/pages/LoginSimulatorLanding/LoginSimulatorOutcome';
import { Link, useParams } from 'react-router-dom';
import { paths } from 'src/frontend-common/components/Router';
import Logo from 'src/frontend-common/components/Logo';
import { NavigateCallbackFn } from 'src/frontend-common/dto/Interfaces/FrontendLookups';

export type LandingState = 'form' | 'success' | 'warning' | 'fail';

const LoginSimulatorLanding: React.FC<{ navigateTo: NavigateCallbackFn }> = () => {
  const [landingState, setLandingState] = useState<LandingState>('form');
  const { username, pw, key } = useParams();
  return (
    <LandingWrapper>
      <Column>
        <div>
          <LinkWrapper to={paths.home.path}>
            <Logo />
          </LinkWrapper>
        </div>
        <>
          {landingState === 'form' && (
            <Column>
              <Typography variant="h2">Log in to your account</Typography>
              <FakeLoginForm setLandingState={setLandingState} currentStep={1} username={username} pw={pw} frontEndAppKey={key} showLabel />
            </Column>
          )}
          {landingState !== 'form' && <LoginSimulatorOutcome landingState={landingState} setLandingState={setLandingState} />}
        </>
      </Column>
    </LandingWrapper>
  );
};

export default LoginSimulatorLanding;

const LinkWrapper = styled(Link)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontWeight: 500,
  lineHeight: 1.6,
  letterSpacing: '0.0075em',
  textDecoration: 'none',
  cursor: 'pointer',
  '&:hover': {
    textDecoration: 'underline',
  },
}));
